import { CLICKREF_PLACEHOLDER, getClickrefFromCookie } from '@/hooks/useClickref';

const ATTRIBUTE = 'data-clickref-url';

function findClickrefAnchor(target: EventTarget | null): HTMLAnchorElement | null {
  if (!(target instanceof Element)) return null;
  const anchor = target.closest(`a[${ATTRIBUTE}]`);
  return anchor instanceof HTMLAnchorElement ? anchor : null;
}

function onDocumentClick(event: MouseEvent): void {
  if (event.defaultPrevented) return;
  if (event.button !== 0) return;
  if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

  const anchor = findClickrefAnchor(event.target);
  if (!anchor) return;

  const rawUrl = anchor.getAttribute(ATTRIBUTE);
  if (!rawUrl) return;

  event.preventDefault();
  const clickref = getClickrefFromCookie();
  const finalUrl = rawUrl.replace(CLICKREF_PLACEHOLDER, encodeURIComponent(clickref));
  window.open(finalUrl, '_blank', 'noopener,noreferrer');
}

let initialized = false;

export function initClickrefDelegation(): void {
  if (initialized || typeof document === 'undefined') return;
  document.addEventListener('click', onDocumentClick);
  initialized = true;
}
